import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {
  constants,
  getNumberOrNull,
  prepareDatosAuxOptions,
  prepareEmpresasOptions,
  responseSelector,
  toTitleCase,
} from '../utils/utils';
import {useAlerts} from '../ui/alert';
import {alertTypes} from '../utils/Alert';
import {log} from '../utils/logs';
import {editEmpresaDuck, editEmpresaThunk} from './duck';
import {CrearEmpresaView} from './CrearEmpresaView';
import {
  getEmpresaDuck,
  getEmpresaThunk,
  getEmpresasDuck,
  getEmpresasThunk,
  getRubrosDuck,
  getRubrosThunk,
  getCargosDuck,
  getCargosThunk,
} from '../oportunidades/duck';

const sinGrupoEmpOption = {value: null, label: 'Sin grupo'};

function EditarEmpresa({history, match, token}) {
  const empresaId = match.params.empresaId;

  const dispatch = useDispatch();

  const modelGetRubros = useSelector(state => state.getRubros);
  const modelEditEmpresa = useSelector(state => state.editEmpresa);
  const modelGetEmpresas = useSelector(state => state.getEmpresas);
  const modelGetEmpresa = useSelector(state => state.getEmpresa);
  const modelGetCargos = useSelector(state => state.getCargos);

  const [grupoEmpresarialOptions, setGrupoEmpresarialOptions] = useState([]);
  const [grupoEmpresarialOption, setGrupoEmpresarialOption] = useState();

  const [nombre, setNombre] = useState('');
  // empresaNombreOriginal guarda el nombre que tiene actualmente la empresa en la BD.
  // Sirve solamente para mostrar el nombre en la lista de oportunidades.
  const [empresaNombreOriginal, setEmpresaNombreOriginal] = useState();
  const [direccion, setDireccion] = useState('');
  const [telefono, setTelefono] = useState('');
  const [correo, setCorreo] = useState('');
  const [razonSocial, setRazonSocial] = useState('');
  const [documento, setDocumento] = useState('');
  const [gerenteGral, setGerenteGral] = useState('');
  const [gerenteGralTelefono, setGerenteGralTelefono] = useState('');
  const [gerenteGralEmail, setGerenteGralEmail] = useState('');
  const [gerenteRrhh, setGerenteRrhh] = useState('');
  const [gerenteRrhhTelefono, setGerenteRrhhTelefono] = useState('');
  const [gerenteRrhhEmail, setGerenteRrhhEmail] = useState('');
  const [esCliente, setEsCliente] = useState(false);
  const [esGrupo, setEsGrupo] = useState(false);
  const [rubrosOptions, setRubrosOptions] = useState();
  const [rubroOption, setRubroOption] = useState();
  const [contactoNombre, setContactoNombre] = useState('');
  const [contactoTelefono, setContactoTelefono] = useState('');
  const [empresaLoadStatus, setEmpresaLoadStatus] = useState('IDLE');
  const [modalRedirect, setModalRedirect] = useState(null);
  const [cargosOptions, setCargosOptions] = useState([]);
  const [cargoOption, setCargoOption] = useState();
  const [emailContacto, setEmailContacto] = useState('');
  const [director, setDirector] = useState('');
  const [directorTelefono, setDirectorTelefono] = useState('');
  const [directorEmail, setDirectorEmail] = useState('');
  const [gerenteComercial, setGerenteComercial] = useState('');
  const [gerenteComercialTelefono, setGerenteComercialTelefono] = useState('');
  const [gerenteComercialEmail, setGerenteComercialEmail] = useState('');
  const [contactoNombreServicio, setContactoNombreServicio] = useState('');
  const [contactoTelefonoServicio, setContactoTelefonoServicio] = useState('');
  const [cargoOptionServicio, setCargoOptionServicio] = useState();
  const [emailContactoServicio, setEmailContactoServicio] = useState('');
  const [readOnly, setReadOnly] = useState(true);
  const {topAlert, setTopAlert, submitAlert, setSubmitAlert} = useAlerts();

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelGetCargos);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getCargosDuck.actions.clear());
    }

    if (data) {
      const datosAuxOptions = prepareDatosAuxOptions(data.items);

      setCargosOptions(datosAuxOptions);

      dispatch(getCargosDuck.actions.clear());
    }
  }, [modelGetCargos]);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelGetEmpresa);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getEmpresaDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      dispatch(getEmpresaDuck.actions.clear());

      const empresa = data.empresa;

      setNombre(empresa.nombre);
      setEmpresaNombreOriginal(empresa.nombre);
      setDireccion(empresa.direccion);
      setTelefono(empresa.telefono ?? "");
      setCorreo(empresa.correo);
      setRazonSocial(empresa.razonSocial);
      setDocumento(empresa.documento);
      setGerenteGral(empresa.gerenteGral);
      setGerenteGralTelefono(empresa.gerenteGralTelefono ?? "");
      setGerenteGralEmail(empresa.gerenteGralEmail);
      setDirector(empresa.director);
      setDirectorTelefono(empresa.directorTelefono ?? "");
      setDirectorEmail(empresa.directorEmail);
      setGerenteComercial(empresa.gerenteComercial);
      setGerenteComercialTelefono(empresa.gerenteComercialTelefono ?? "");
      setGerenteComercialEmail(empresa.gerenteComercialEmail);
      setGerenteRrhh(empresa.gerenteRrhh);
      setGerenteRrhhTelefono(empresa.gerenteRrhhTelefono ?? "");
      setGerenteRrhhEmail(empresa.gerenteRrhhEmail);
      setEsCliente(empresa.esCliente);
      setEsGrupo(empresa.esGrupo);
      setRubroOption(
        rubrosOptions.find(
          rubroOption => empresa.rubroIdNumerico === rubroOption.value,
        ),
      );
      setContactoNombre(empresa.contacto?.nombre);
      setContactoNombreServicio(empresa.servicio?.nombre);
      setEmailContacto(empresa.contacto?.email);
      setEmailContactoServicio(empresa.servicio?.email);
      setContactoTelefono(empresa.contacto?.telefono ?? "");
      setContactoTelefonoServicio(empresa.servicio?.telefono ?? "");
      const grupoEmp = grupoEmpresarialOptions.find(
        grupoEmpresarialOption =>
          empresa.empresaPadreId === grupoEmpresarialOption.value,
      );

      const cargoContactoAdm = cargosOptions.find(
        cargo => empresa.contacto?.cargo === cargo.value,
      );
      setCargoOption(cargoContactoAdm);
      const cargoContactoServicio = cargosOptions.find(
        cargo => empresa.servicio?.cargo === cargo.value,
      );
      setCargoOptionServicio(cargoContactoServicio);
      setGrupoEmpresarialOption(grupoEmp ?? sinGrupoEmpOption);
      setEmpresaLoadStatus('LOADED');
    }
  }, [modelGetEmpresa]);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelGetEmpresas);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getEmpresasDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      dispatch(getEmpresasDuck.actions.clear());

      setGrupoEmpresarialOptions([
        sinGrupoEmpOption,
        ...prepareEmpresasOptions(data.items),
      ]);
    }
  }, [modelGetEmpresas]);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelEditEmpresa);

    if (error) {
      setSubmitAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(editEmpresaDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      dispatch(editEmpresaDuck.actions.clear());
      setReadOnly(true);
      setSubmitAlert({
        text: 'Empresa editada correctamente',
        type: alertTypes.success,
        closable: false,
      });
    }
  }, [modelEditEmpresa]);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelGetRubros);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getRubrosDuck.actions.clear());
    }

    if (data) {
      // log({ 'modelGetRubros.useEffect.data': data });

      const datosAuxOptions = prepareDatosAuxOptions(data.items);
      // log({ datosAuxOptions });

      setRubrosOptions([{value: null, label: 'Ninguno'}, ...datosAuxOptions]);

      dispatch(getRubrosDuck.actions.clear());
    }
  }, [modelGetRubros]);

  useEffect(() => {
    dispatch(
      getEmpresasThunk({
        esGrupo: 'SI',
        userToken: token.raw,
      }),
    );
    dispatch(
      getRubrosThunk({
        userToken: token.raw,
      }),
    );
    dispatch(
      getCargosThunk({
        userToken: token.raw,
      }),
    );
  }, []);

  useEffect(() => {
    if (rubrosOptions && grupoEmpresarialOptions && cargosOptions) {
      setEmpresaLoadStatus('LOADING');
      dispatch(
        getEmpresaThunk({
          idNumerico: empresaId,
          userToken: token.raw,
        }),
      );
    }
  }, [rubrosOptions, grupoEmpresarialOptions, cargosOptions]);

  function submit() {
    let data = {
      empresaId,
      userToken: token.raw,
      nombre,
      direccion,
      telefono,
      correo,
      razonSocial,
      documento,
      gerenteGral,
      gerenteRrhh,
      esCliente,
      esGrupo,
      rubroIdNumerico: rubroOption?.value,
      contactoNombre,
      contactoTelefono,
      contactoCargo: cargoOption?.value,
      contactoCargoNombre: cargoOption?.label,
      contactoEmail: emailContacto,
      contactoServicioNombre: contactoNombreServicio,
      contactoServicioTelefono: contactoTelefonoServicio,
      contactoServicioCargo: cargoOptionServicio?.value,
      contactoServicioCargoNombre: cargoOptionServicio?.label,
      contactoServicioEmail: emailContactoServicio,
      director,
      gerenteComercial,
      empresaPadreId: grupoEmpresarialOption?.value,
    };

    log({'submit.data': data});

    dispatch(editEmpresaThunk(data));
  }

  return (
    <CrearEmpresaView
      mode="edit"
      history={history}
      match={match}
      modelCreateEmpresa={modelEditEmpresa}
      submit={submit}
      submitAlert={submitAlert}
      topAlert={topAlert}
      modelGetEmpresa={modelGetEmpresa}
      nombre={nombre}
      setNombre={setNombre}
      direccion={direccion}
      setDireccion={setDireccion}
      telefono={telefono}
      setTelefono={setTelefono}
      correo={correo}
      setCorreo={setCorreo}
      razonSocial={razonSocial}
      setRazonSocial={setRazonSocial}
      documento={documento}
      setDocumento={setDocumento}
      gerenteGral={gerenteGral}
      setGerenteGral={setGerenteGral}
      gerenteGralTelefono={gerenteGralTelefono}
      setGerenteGralTelefono={setGerenteGralTelefono}
      gerenteGralEmail={gerenteGralEmail}
      setGerenteGralEmail={setGerenteGralEmail}
      gerenteRrhh={gerenteRrhh}
      setGerenteRrhh={setGerenteRrhh}
      gerenteRrhhTelefono={gerenteRrhhTelefono}
      setGerenteRrhhTelefono={setGerenteRrhhTelefono}
      gerenteRrhhEmail={gerenteRrhhEmail}
      setGerenteRrhhEmail={setGerenteRrhhEmail}
      esCliente={esCliente}
      setEsCliente={setEsCliente}
      esGrupo={esGrupo}
      setEsGrupo={setEsGrupo}
      contactoNombre={contactoNombre}
      setContactoNombre={setContactoNombre}
      contactoTelefono={contactoTelefono}
      setContactoTelefono={setContactoTelefono}
      rubroOption={rubroOption}
      rubrosOptions={rubrosOptions}
      setRubroOption={setRubroOption}
      grupoEmpresarialOptions={grupoEmpresarialOptions}
      grupoEmpresarialOption={grupoEmpresarialOption}
      setGrupoEmpresarialOption={setGrupoEmpresarialOption}
      empresaId={empresaId}
      empresaNombreOriginal={empresaNombreOriginal}
      empresaLoadStatus={empresaLoadStatus}
      modalRedirect={modalRedirect}
      setModalRedirect={setModalRedirect}
      director={director}
      setDirector={setDirector}
      directorTelefono={directorTelefono}
      setDirectorTelefono={setDirectorTelefono}
      directorEmail={directorEmail}
      setDirectorEmail={setDirectorEmail}
      cargoOption={cargoOption}
      cargosOptions={cargosOptions}
      setCargoOption={setCargoOption}
      emailContacto={emailContacto}
      setEmailContacto={setEmailContacto}
      contactoNombreServicio={contactoNombreServicio}
      setContactoNombreServicio={setContactoNombreServicio}
      contactoTelefonoServicio={contactoTelefonoServicio}
      setContactoTelefonoServicio={setContactoTelefonoServicio}
      cargoOptionServicio={cargoOptionServicio}
      setCargoOptionServicio={setCargoOptionServicio}
      emailContactoServicio={emailContactoServicio}
      setEmailContactoServicio={setEmailContactoServicio}
      gerenteComercial={gerenteComercial}
      setGerenteComercial={setGerenteComercial}
      gerenteComercialTelefono={gerenteComercialTelefono}
      setGerenteComercialTelefono={setGerenteComercialTelefono}
      gerenteComercialEmail={gerenteComercialEmail}
      setGerenteComercialEmail={setGerenteComercialEmail}
      readOnly={readOnly}
      setReadOnly={setReadOnly}
    />
  );
}

export {EditarEmpresa};
